import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, Button, Card, Center, Loader, PasswordInput, Stack, Text, Title } from '@mantine/core';

import { unwrap } from '../api/client';
import { checkPasswordLink, setPassword as setPasswordCall } from '../api/gen';

// Where the "new password" mail lands.
//
// The link is checked before anything is typed, and checking does not spend
// it: somebody who opens a dead link should be told so on arrival rather than
// after choosing a password they then have to choose again.
export function SetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [link, setLink] = useState<'checking' | 'good' | 'dead'>('checking');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setLink('dead');
      setError('Diesem Link fehlt sein Token.');
      return;
    }
    void (async () => {
      try {
        await unwrap(checkPasswordLink({ body: { token } }));
        setLink('good');
      } catch (err) {
        setError((err as Error).message);
        setLink('dead');
      }
    })();
  }, [token]);

  const submit = () => {
    setBusy(true);
    setError('');
    void (async () => {
      try {
        await unwrap(setPasswordCall({ body: { token, password } }));
        setDone(true);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setBusy(false);
      }
    })();
  };

  return (
    <Center mih="100vh" p="md">
      <Card withBorder padding="xl" radius="md" w={420} maw="100%">
        <Stack>
          <Title order={3}>Passwort setzen</Title>
          {link === 'checking' ? <Loader size="sm" /> : null}
          {error ? (
            <Alert color="red" variant="light">
              {error}
            </Alert>
          ) : null}
          {done ? (
            <>
              <Text size="sm">
                Das Passwort ist gesetzt. Alle alten Sitzungen wurden beendet.
              </Text>
              <Button component="a" href="/">
                Zur Anmeldung
              </Button>
            </>
          ) : link === 'good' ? (
            <>
              <PasswordInput
                label="Neues Passwort"
                description="Mindestens zwölf Zeichen."
                value={password}
                onChange={(e) => setPassword(e.currentTarget.value)}
              />
              <Button disabled={!password || busy} loading={busy} onClick={submit}>
                Passwort setzen
              </Button>
            </>
          ) : link === 'dead' ? (
            <Button component="a" href="/" variant="light">
              Zur Anmeldung
            </Button>
          ) : null}
        </Stack>
      </Card>
    </Center>
  );
}
